<markant-dialog
  class="add-cartridges-dialog"
  [open]="
    isDialogOpen &&
    !(submitted === 'VALID') &&
    currentStep === steps.CartridgeSelection
  "
  [headTitle]="'usageRight.addCartridgesDialog.headTitle' | transloco"
  [subTitle]="
    'usageRight.addCartridgesDialog.subTitle' + (isNewOrg ? 'NewOrg' : '')
      | transloco
  "
  (close)="closeDialog.emit()"
>
  <markant-progress-bar
    *ngIf="!cartridgesForm"
    [indeterminate]="true"
  ></markant-progress-bar>
  <markant-platform-organization-add-cartridges-stepper
    [currentStep]="currentStep"
  ></markant-platform-organization-add-cartridges-stepper>
  <p *ngIf="!isNewOrg">
    {{ 'usageRight.addCartridgesDialog.notice' | transloco }}
  </p>
  <div
    *ngIf="cartridgesForm && (isNewOrg || organizationAdmins) && variantData"
    class="content"
    [formGroup]="cartridgesForm"
  >
    <div class="table-wrapper">
      <markant-table
        class="cartridges-table"
        formArrayName="cartridges"
        [noHover]="true"
      >
        <tr slot="header-row">
          <th
            scope="col"
            *ngIf="
              (!submitted || submitted === 'INVALID') && !singleSelectionId
            "
            class="checkbox-col markant-table__cell--checkbox"
          >
            <markant-checkbox
              [checked]="allCartridgesSelected(cartridgesFormArray)"
              (checkedChange)="
                toggleAllCartridges($any($event).detail, cartridgesFormArray)
              "
            ></markant-checkbox>
          </th>
          <th scope="col" class="text-col">
            {{
              'usageRight.addCartridgesDialog.table.cartridgeCol' | transloco
            }}
          </th>
          <th scope="col" class="dropdown-col">
            {{ 'usageRight.addCartridgesDialog.table.variantCol' | transloco }}
          </th>
          <th scope="col" class="boolean-col">
            {{
              'usageRight.addCartridgesDialog.table.platformBillingCol'
                | transloco
            }}
          </th>
          <th scope="col" class="text-col">
            {{ 'usageRight.addCartridgesDialog.table.priceCol' | transloco }}
          </th>
          <th *ngIf="!isNewOrg" scope="col" class="dropdown-col">
            {{ 'usageRight.addCartridgesDialog.table.adminCol' | transloco }}
          </th>
          <th scope="col" class="dropdown-col">
            {{
              'usageRight.addCartridgesDialog.table.bookingReferenceCol'
                | transloco
            }}
          </th>
        </tr>
        <ng-container
          *ngFor="
            let unbookedCartridge of cartridgesFormArray.controls;
            let index = index
          "
        >
          <ng-container
            *ngIf="unbookedCartridge.getRawValue()?.cartridge as cartridge"
          >
            <tr
              *ngIf="
                !singleSelectionId ||
                singleSelectionId === cartridge?.cartridgeId
              "
              [formGroupName]="index"
              class="table-row"
            >
              <td
                *ngIf="!singleSelectionId"
                class="checkbox-col markant-table__cell--checkbox"
              >
                <markant-checkbox formControlName="selected"></markant-checkbox>
              </td>
              <td>
                <div [title]="cartridge?.cartridgeName">
                  {{ cartridge?.cartridgeName }}
                </div>
              </td>
              <td *ngIf="cartridge?.cartridgeId" class="select-dropdown">
                <markant-select
                  #cartridgeSelect
                  formControlName="cartridgeVariantId"
                  [outlined]="true"
                  [title]="
                    getCartridgeVariantName(
                      cartridge?.cartridgeId,
                      cartridgeSelect.value
                    )
                  "
                  [error]="
                    submitted === 'INVALID' &&
                    (unbookedCartridge.get('cartridgeVariantId')?.invalid ??
                      false)
                      ? ' '
                      : undefined
                  "
                  [placeholder]="
                    'usageRight.addCartridgesDialog.table.variantPlaceholder'
                      | transloco
                  "
                  [options]="variantOptions[cartridge?.cartridgeId]"
                  (valueChange)="onVariantSelect(index)"
                >
                </markant-select>
              </td>
              <td class="select-dropdown">
                <markant-select
                  class="select"
                  formControlName="platformBilling"
                  [outlined]="true"
                  [title]="'Platform Billing'"
                  [error]="
                    submitted === 'INVALID' &&
                    unbookedCartridge.controls['platformBilling'].invalid
                      ? ' '
                      : undefined
                  "
                  (valueChange)="onPlatformBillingChanged(index)"
                  [options]="platformBillingOptions"
                >
                </markant-select>
              </td>
              <td>
                @if (
                  unbookedCartridge.controls['overwriteCentAmount'].value ===
                  NOT_APPLICABLE
                ) {
                  <markant-input
                    data-cy="input-overwrite-cent-amount"
                    class="input"
                    type="text"
                    unit="€"
                    formControlName="overwriteCentAmount"
                    [useCustomLayout]="true"
                    [outlined]="true"
                  >
                  </markant-input>
                } @else {
                  <markant-currency-input
                    currencyLocale="{{ activeLanguage$ | async }}"
                    type="text"
                    formControlName="overwriteCentAmount"
                  >
                    <markant-input
                      data-cy="input-overwrite-cent-amount"
                      class="input"
                      type="text"
                      unit="€"
                      formControlName="overwriteCentAmount"
                      [debounce]="300"
                      [useCustomLayout]="true"
                      [outlined]="true"
                      [error]="
                        submitted === 'INVALID' &&
                        (unbookedCartridge.get('overwriteCentAmount')
                          ?.invalid ??
                          false)
                      "
                      (valueChange)="
                        onOverwriteCentAmountChanged($any($event).detail, index)
                      "
                    >
                    </markant-input>
                  </markant-currency-input>
                }
              </td>

              <td *ngIf="!isNewOrg" class="select-dropdown">
                <markant-select
                  #adminSelect
                  class="org-admin-select"
                  formControlName="orgAdminId"
                  [outlined]="true"
                  [title]="getOrgAdminNameEmail(adminSelect.value)"
                  [error]="
                    submitted === 'INVALID' &&
                    (unbookedCartridge.get('orgAdminId')?.invalid ?? false)
                      ? ' '
                      : undefined
                  "
                  [placeholder]="
                    'usageRight.addCartridgesDialog.table.adminPlaceholder'
                      | transloco
                  "
                  [options]="orgAdminOptions"
                >
                </markant-select>
              </td>
              <td>
                <markant-input
                  data-cy="input-booking-reference"
                  class="input"
                  formControlName="bookingReference"
                  [useCustomLayout]="true"
                  [outlined]="true"
                ></markant-input>
              </td>
            </tr>
          </ng-container>
        </ng-container>
        <tr *ngIf="!cartridgesFormArray.length">
          <td class="no-results" [attr.colspan]="isNewOrg ? 3 : 4">
            {{ 'usageRight.addCartridgesDialog.table.noResults' | transloco }}
          </td>
        </tr>
      </markant-table>
    </div>
  </div>
  <div class="footer" slot="footer">
    <span class="validation-error-message">
      <ng-container *ngIf="submitted && cartridgesForm?.invalid">
        <markant-icon
          class="validation-error-message-icon"
          icon="m_warning-small"
          colorScheme="error"
        >
        </markant-icon>
        {{
          'usageRight.addCartridgesDialog.validationErrorMessage' | transloco
        }}
      </ng-container>
    </span>
    <div class="button-bar">
      <markant-button
        colorScheme="primary"
        variant="clear"
        name="close-dialog-btn"
        data-markant-dialog-action="cancel"
        class="button-space"
      >
        {{ 'usageRight.addCartridgesDialog.cancelButton' | transloco }}
      </markant-button>
      <markant-button
        colorScheme="primary"
        name="close-dialog-btn"
        (click)="setFormSubmitted()"
        [disabled]="
          cartridgesFormArray ? hasNoSelection(cartridgesFormArray) : true
        "
      >
        {{ 'usageRight.addCartridgesDialog.nextButton' | transloco }}
      </markant-button>
    </div>
  </div>
</markant-dialog>

<markant-dialog
  *ngIf="
    isDialogOpen &&
    submitted === 'VALID' &&
    currentStep === steps.OrganizationDataCompletion
  "
  class="add-cartridges-organization-complete-dialog"
  [open]="isDialogOpen"
  [headTitle]="
    'usageRight.addCartridgesDialog.organizationCompletion.header' | transloco
  "
  [subTitle]="
    'usageRight.addCartridgesDialog.organizationCompletion.subHeader'
      | transloco
  "
  (close)="closeDialog.emit()"
>
  <markant-platform-organization-add-cartridges-stepper
    [currentStep]="currentStep"
  ></markant-platform-organization-add-cartridges-stepper>
  <div class="content">
    <div class="organization-completion-content">
      <div
        class="organization-completion-text"
        [innerHTML]="
          'usageRight.addCartridgesDialog.organizationCompletion.text'
            | transloco
        "
      ></div>
      <markant-seperator
        class="seperator"
        orientation="vertical"
      ></markant-seperator>
      <div>
        <form
          *ngIf="organizationCompletionForm"
          class="organization-completion-form"
          [formGroup]="organizationCompletionForm"
        >
          <markant-input
            *ngIf="
              organizationCompletionForm.controls['masterKin'] as masterKin
            "
            formControlName="masterKin"
            class="input"
            data-cy="input-master-kin"
            [maxlength]="8"
            [label]="
              'usageRight.addCartridgesDialog.organizationCompletion.masterKin'
                | transloco
            "
            [required]="true"
            [showLabelHint]="true"
            [placeholder]="'22211100'"
            [helper]="'organization.details.fields.masterKin.hint' | transloco"
            [helperCharacterCounter]="true"
            [error]="
              submittedOrganizationCompletionForm === 'INVALID' &&
              (masterKin.errors
                | formControlError: masterKin.touched || masterKin.dirty)
            "
            [errorText]="
              submittedOrganizationCompletionForm === 'INVALID' &&
              (masterKin.errors
                | formControlKeyError
                  : 'usageRight.addCartridgesDialog.organizationCompletion.masterKinValidation'
                  : masterKin.touched || masterKin.dirty
                | transloco)
            "
            [outlined]="true"
          >
          </markant-input>
          <markant-input
            *ngIf="
              organizationCompletionForm.controls[
                'billingEmail'
              ] as billingEmail
            "
            formControlName="billingEmail"
            class="input"
            data-cy="input-billing-email"
            [label]="
              'usageRight.addCartridgesDialog.organizationCompletion.email'
                | transloco
            "
            [required]="true"
            [showLabelHint]="true"
            [error]="
              submittedOrganizationCompletionForm === 'INVALID' &&
              (billingEmail.errors
                | formControlError: billingEmail.touched || billingEmail.dirty)
            "
            [errorText]="
              submittedOrganizationCompletionForm === 'INVALID' &&
              (billingEmail.errors
                | formControlKeyError
                  : 'usageRight.addCartridgesDialog.organizationCompletion.emailValidation'
                  : billingEmail.touched || billingEmail.dirty
                | transloco)
            "
            [outlined]="true"
          >
          </markant-input>
          <markant-select
            formControlName="billingLanguageIsoCode"
            class="form-input-selection"
            name="billingLanguageIsoCode"
            [required]="true"
            [outlined]="true"
            [label]="
              'usageRight.addCartridgesDialog.organizationCompletion.language'
                | transloco
            "
            [showLabelHint]="true"
            [options]="billingLanguageIsoCodeOptions"
          >
          </markant-select>
        </form>
      </div>
    </div>
  </div>
  <div class="footer" slot="footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="reenableForm()"
    >
      <markant-icon
        class="back-button-icon"
        slot="icon-leading"
        icon="m_arrow-left"
      ></markant-icon>
      {{ 'usageRight.addCartridgesDialog.confirmation.backButton' | transloco }}
    </markant-button>
    <span class="validation-error-message">
      <ng-container
        *ngIf="
          submittedOrganizationCompletionForm &&
          organizationCompletionForm?.invalid
        "
      >
        <markant-icon
          class="validation-error-message-icon"
          icon="m_warning-small"
          colorScheme="error"
        >
        </markant-icon>
        {{
          'usageRight.addCartridgesDialog.validationErrorMessage' | transloco
        }}
      </ng-container>
    </span>
    <div class="button-bar">
      <markant-button
        colorScheme="primary"
        variant="clear"
        name="close-dialog-btn"
        data-markant-dialog-action="cancel"
        class="button-space"
      >
        {{ 'usageRight.addCartridgesDialog.cancelButton' | transloco }}
      </markant-button>
      <markant-button
        colorScheme="primary"
        name="close-dialog-btn"
        (click)="nextToConfirmation()"
        [disabled]="
          cartridgesFormArray ? hasNoSelection(cartridgesFormArray) : true
        "
      >
        {{ 'usageRight.addCartridgesDialog.nextButton' | transloco }}
      </markant-button>
    </div>
  </div>
</markant-dialog>

<markant-dialog
  *ngIf="
    isDialogOpen && submitted === 'VALID' && currentStep === steps.Confirmation
  "
  class="add-cartridges-summary-dialog"
  [open]="isDialogOpen"
  (close)="closeDialog.emit()"
  [headTitle]="
    'usageRight.addCartridgesDialog.confirmation.headTitle' | transloco
  "
  [subTitle]="
    'usageRight.addCartridgesDialog.confirmation.subTitle' +
      (organizationName ? 'NewOrg' : '')
      | transloco
        : {
            organisationName:
              organizationName | defaultValue: organization?.name,
          }
  "
>
  <markant-platform-organization-add-cartridges-stepper
    [currentStep]="currentStep"
  ></markant-platform-organization-add-cartridges-stepper>
  <div class="content">
    <div
      *ngIf="organizationCompletionForm && submittedOrganizationCompletionForm"
      class="completion-content"
    >
      <div>
        <div class="completion-content-text">
          {{
            'usageRight.addCartridgesDialog.organizationCompletion.masterKin'
              | transloco
          }}
        </div>
        <div>{{ organizationCompletionForm.controls['masterKin'].value }}</div>
      </div>
      <div>
        <div class="completion-content-text">
          {{
            'usageRight.addCartridgesDialog.organizationCompletion.email'
              | transloco
          }}
        </div>
        <div>
          {{ organizationCompletionForm.controls['billingEmail'].value }}
        </div>
      </div>
      <div>
        <div class="completion-content-text">
          {{
            'usageRight.addCartridgesDialog.organizationCompletion.language'
              | transloco
          }}
        </div>
        <div>
          {{
            'languageSelect.' +
              (organizationCompletionForm.controls['billingLanguageIsoCode']
                .value | lowercase) | transloco
          }}
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <markant-table class="cartridges-table" [noHover]="true">
        <tr slot="header-row">
          <th scope="col" class="text-col">
            {{
              'usageRight.addCartridgesDialog.table.cartridgeCol' | transloco
            }}
          </th>
          <th scope="col" class="dropdown-col">
            {{ 'usageRight.addCartridgesDialog.table.variantCol' | transloco }}
          </th>
          <th scope="col" class="boolean-col">
            {{
              'usageRight.addCartridgesDialog.table.platformBillingCol'
                | transloco
            }}
          </th>
          <th scope="col" class="text-col">
            {{ 'usageRight.addCartridgesDialog.table.priceCol' | transloco }}
          </th>
          <th scope="col" class="dropdown-col" *ngIf="!isNewOrg">
            {{ 'usageRight.addCartridgesDialog.table.adminCol' | transloco }}
          </th>
          <th scope="col" class="dropdown-col">
            {{
              'usageRight.addCartridgesDialog.table.bookingReferenceCol'
                | transloco
            }}
          </th>
        </tr>
        <ng-container
          *ngFor="
            let selectedCartridge of selectedCartridges;
            let index = index;
            trackBy: trackByFn
          "
        >
          <tr
            *ngIf="
              !singleSelectionId ||
              singleSelectionId === selectedCartridge?.cartridgeId
            "
          >
            <td>
              <div [title]="selectedCartridge.cartridgeName">
                {{ selectedCartridge.cartridgeName }}
              </div>
            </td>
            <td>
              <div
                [title]="
                  getVariantNameById(
                    selectedCartridge.cartridgeId,
                    selectedCartridge.cartridgeVariantId
                  )
                "
              >
                <span>{{
                  getVariantNameById(
                    selectedCartridge.cartridgeId,
                    selectedCartridge.cartridgeVariantId
                  )
                }}</span>
              </div>
            </td>
            <td>
              <div
                [title]="
                  'common.' + selectedCartridge.platformBilling | transloco
                "
              >
                {{ 'common.' + selectedCartridge.platformBilling | transloco }}
              </div>
            </td>
            <td>
              <div
                [title]="
                  !selectedCartridge.overwriteCentAmount
                    ? (selectedCartridge.overwriteCentAmount
                      | defaultValue: 'usageRight.addCartridgesDialog.unset'
                      | transloco)
                    : selectedCartridge.overwriteCentAmount
                "
              >
                <span>
                  {{
                    !selectedCartridge.overwriteCentAmount
                      ? (selectedCartridge.overwriteCentAmount
                        | defaultValue: 'usageRight.addCartridgesDialog.unset'
                        | transloco)
                      : selectedCartridge.overwriteCentAmount
                  }}
                  {{
                    selectedCartridge.overwriteCentAmount &&
                    selectedCartridge.overwriteCentAmount !== NOT_APPLICABLE
                      ? '€'
                      : ''
                  }}
                </span>
              </div>
            </td>
            <td *ngIf="!isNewOrg">
              <ng-container
                *ngIf="
                  getOrgAdminById(selectedCartridge.orgAdminId) as orgAdmin
                "
              >
                <div
                  class="org-admin-readonly"
                  [attr.id]="'org-admin-' + index"
                >
                  <span class="org-admin-name-readonly">
                    {{ orgAdmin.firstname }} {{ orgAdmin.lastname }}
                  </span>
                  <br />
                  <span>{{ orgAdmin.email }}</span>
                </div>
                <markant-tooltip
                  [attr.for]="'org-admin-' + index"
                  label="{{ orgAdmin.firstname }} {{ orgAdmin.lastname }} {{
                    orgAdmin.email
                  }}"
                  placement="top"
                ></markant-tooltip>
              </ng-container>
            </td>
            <td>
              <div [title]="selectedCartridge.bookingReference">
                {{ selectedCartridge.bookingReference }}
              </div>
            </td>
          </tr>
        </ng-container>
      </markant-table>
    </div>
  </div>
  <div class="footer" slot="footer">
    <markant-button
      colorScheme="primary"
      variant="clear"
      (click)="backToOrganizationDataCompletion()"
    >
      <markant-icon
        class="back-button-icon"
        slot="icon-leading"
        icon="m_arrow-left"
      ></markant-icon>
      {{ 'usageRight.addCartridgesDialog.confirmation.backButton' | transloco }}
    </markant-button>
    <div class="button-bar">
      <markant-button
        colorScheme="primary"
        variant="clear"
        data-markant-dialog-action="cancel"
        class="button-space"
      >
        {{ 'usageRight.addCartridgesDialog.cancelButton' | transloco }}
      </markant-button>
      <markant-button
        [loading]="isLoading"
        colorScheme="primary"
        (click)="
          isNewOrg
            ? updateCartridgeSelection()
            : orderSelectedCartridges(organization)
        "
      >
        {{
          'usageRight.addCartridgesDialog.confirmation.' +
            (selectedCartridges.length > 1
              ? 'confirmationButtonMultiple'
              : 'confirmationButtonSingle') | transloco
        }}
      </markant-button>
    </div>
  </div>
</markant-dialog>
